import React from 'react';
import Connection from '../components/Connection';

export const Contact = ():JSX.Element => {
  return (
    <>
      <Connection />
    </>
  );
}
